import { render, staticRenderFns } from "./SyncProductDialog.vue?vue&type=template&id=9b0460ea&scoped=true&"
import script from "./SyncProductDialog.vue?vue&type=script&lang=js&"
export * from "./SyncProductDialog.vue?vue&type=script&lang=js&"
import style0 from "./SyncProductDialog.vue?vue&type=style&index=0&id=9b0460ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0460ea",
  null
  
)

export default component.exports